module.exports = __webpack_public_path__ + "media/icons/txt-file-622f0ff6.png";